import React, { useEffect, useState } from "react";

const ScheduleTableClass = ({ lstPeriodHdr, currentDayData }) => {
    const [dayData, setDayData] = useState({});
    const [lstPeriod, setLstPeriod] = useState([]);
    const [clsFiltered, setClsFiltered] = useState("");

    useEffect(() => {
        // console.log("ScheduleTableClass called, currentDayData", currentDayData, ", lstPeriodHdr", lstPeriodHdr);
        setDayData(currentDayData);
        setLstPeriod(lstPeriodHdr);
    }, [currentDayData, lstPeriodHdr]);

    const getPeriodData = (period) => {
        // console.log("getPeriodData called, period", period);
        const allocationCount = period.lstPeriod.length;
        return {
            periodCount: allocationCount,
            periodInfo: period.lstPeriod[0]
        };
    }


    const renderPeriodCell = (period) => {
        const { lstPeriod } = period; // Safely handle undefined lstPeriod

        if (!lstPeriod.length) return null; // Handle empty lstPeriod


        // Helper function to render a single period with dynamic font sizes
        const renderSinglePeriod = (p, fontSizeSubject, fontSizeClass) => (
            <div style={{width:'100%'}}>
                <div
                    style={{
                        lineHeight: "normal",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        fontSize: `${fontSizeSubject}px`,
                        fontWeight: "bold",
                        marginTop: "10px",
                        textAlign:'center', width:'100%'
                    }}
                >
                    {p?.tch?.substr(0,7) || "-"}
                </div>
                <div
                    style={{
                        alignContent: "center",
                        fontSize: `${fontSizeClass}px`,
                        marginTop: "10px",
                        marginBottom: "10px",
                        textAlign: "left",
                    }}
                >
                    {p?.sub}
                </div>
            </div>
        );

        // Set font sizes based on number of partitions
        const fontSizeMap = {
            1: { subject: 14, class: 12 },
            2: { subject: 12, class: 10 },
            3: { subject: 10, class: 8 },
            4: { subject: 10, class: 8 },
            6: { subject: 8, class: 6 },
        };
        const fontSize = fontSizeMap[lstPeriod.length] || { subject: 8, class: 6 };

        // Condition 1: Only one period
        if (lstPeriod.length === 1) {
            return (
                <div style={{ display: "flex" }}>
                    {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                </div>
            );
        }

        // Condition 2: Two periods with vertical partition
        if (lstPeriod.length === 2) {
            return (
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: 1, borderRight: "1px solid #ccc", padding: "0 5px" }}>
                        {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                    </div>
                    <div style={{ flex: 1, padding: "0 5px" }}>
                        {renderSinglePeriod(lstPeriod[1], fontSize.subject, fontSize.class)}
                    </div>
                </div>
            );
        }

        // Condition 4: Four periods
        if (lstPeriod.length <= 4) {
            return (
                <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", height: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #ccc" }}>
                        <div style={{ flex: 1, padding: "0 5px", borderRight: "1px solid #ccc" }}>
                            {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                        </div>
                        <div style={{ flex: 1, padding: "0 5px" }}>
                            {renderSinglePeriod(lstPeriod[1], fontSize.subject, fontSize.class)}
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ flex: 1, padding: "0 5px", borderRight: "1px solid #ccc" }}>
                            {renderSinglePeriod(lstPeriod[2], fontSize.subject, fontSize.class)}
                        </div>
                        <div style={{ flex: 1, padding: "0 5px" }}>
                            {lstPeriod[3] ? renderSinglePeriod(lstPeriod[3], fontSize.subject, fontSize.class) : null}
                        </div>

                    </div>
                </div>
            );
        }

        // Condition 5: More than four periods
        if (lstPeriod.length > 4) {
            return (
                <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", height: "100%" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", borderBottom: "1px solid #ccc" }}>
                        {lstPeriod.slice(0, 3).map((p, idx) => (
                            <div key={idx} style={{ padding: "0 5px", borderRight: idx < 2 ? "1px solid #ccc" : "none" }}>
                                {renderSinglePeriod(p, fontSize.subject, fontSize.class)}
                            </div>
                        ))}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
                        {lstPeriod.slice(3, 6).map((p, idx) => (
                            <div key={idx} style={{ padding: "0 5px", borderRight: idx < 2 ? "1px solid #ccc" : "none" }}>
                                {renderSinglePeriod(p, fontSize.subject, fontSize.class)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return null;
    };


    const filteredSections = (dayData && dayData.lstSection ? dayData.lstSection : [])
        .filter((obj) => obj.clsSection.toLowerCase().includes(clsFiltered.trim().toLowerCase()));

    // data abhi load nahi hui (koi period column nahi) - table hi mat dikhao,
    // warna akela filter-box poori width le leta hai
    if (!lstPeriod || lstPeriod.length === 0) {
        return null;
    }

    return (
        <div className="table-responsive horizontalScrolll-schedule-tt normalplace-schedule-tt">
            <table className="table table-bordered table-hover" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                    <tr>
                        <th style={{ width: "100px", textAlign: "center", verticalAlign: "middle" }}>
                            <input
                                type="text"
                                className="form-control inp-search"
                                style={{ textAlign: "center", margin: "0 auto" }}
                                value={clsFiltered}
                                onChange={(e) => setClsFiltered(e.target.value)}
                                placeholder="Class" />
                        </th>
                        {lstPeriod && lstPeriod.length ?
                            lstPeriod.map((period) => (
                                <th
                                    key={period.schedulePeriodId}
                                    style={{ width: "75px", textAlign: "center", verticalAlign: "middle" }}
                                >
                                    {period.period}
                                </th>
                            )) : null
                        }
                    </tr>
                </thead>
                <tbody>
                    {filteredSections && filteredSections.length ?
                        filteredSections.map((obj) => (
                            <tr key={'s_' + obj.sectionId}>
                                <td
                                    style={{
                                        width: "100px",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    <div
                                        style={{
                                            lineHeight: "normal",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            fontSize: "15px",
                                            marginTop: "10px",
                                        }}
                                    >{obj.clsSection}
                                    </div>
                                    <div
                                        style={{
                                            alignContent: "center",
                                            fontSize: "11px",
                                            marginTop: "20px",
                                            marginBottom: "0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        {obj?.clsTch}
                                    </div>
                                </td>
                                {obj.lstMstCell && obj.lstMstCell.length ?
                                    obj.lstMstCell.map((period, idx) => {
                                        const bgColor = !lstPeriod[idx].assignTeacher ? "#EEEEEE" : ""
                                        return (
                                            <td
                                                key={period.schedulePeriodId}
                                                style={{
                                                    width: "75px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    height: period.length > 0 ? "auto" : "60px",
                                                    background: bgColor,
                                                    lineHeight: "normal",
                                                }}
                                            >
                                                {renderPeriodCell(period)}
                                            </td>
                                        );
                                    }) : null
                                }
                            </tr>
                        )) : null
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ScheduleTableClass;